/// <refrence path="./router/index.d.ts" />
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import * as API from '@/api/api'
import Vconsole from 'vconsole'
import 'xgplayer/dist/index.min.css'
import {
  Lazyload,
  Cell,
  CellGroup,
  Switch,
  Popup,
  Icon,
  NoticeBar,
  Swipe,
  SwipeItem,
  Search,
  List,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Button,
  Rate,
  Field,
  Circle,
  Loading,
  Overlay,
  Toast,
  Dialog,
  Tag,
  Image as VanImage,
  Form,
  Area,
  DropdownMenu,
  DropdownItem,
  Notify
} from 'vant'
Vue.use(Lazyload)
  .use(Cell)
  .use(CellGroup)
  .use(Switch)
  .use(Popup)
  .use(Icon)
  .use(NoticeBar)
  .use(Swipe)
  .use(SwipeItem)
  .use(Search)
  .use(List)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Button)
  .use(Rate)
  .use(Field)
  .use(Circle)
  .use(Loading)
  .use(Overlay)
  .use(Toast)
  .use(Dialog)
  .use(Tag)
  .use(VanImage)
  .use(Form)
  .use(Area)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Notify)
Vue.config.productionTip = false
Vue.prototype.$API = API
// 注册全局时间总线
// Vue.prototype.$bus = this
// 开放语音设别权限,支持IOS, Android ，不支持PC
window.fosun_oapi_login.config(undefined, [
  'device.audio.startRecord',
  'device.audio.stopRecord',
  'device.audio.translateVoice'
])

if (process.env.NODE_ENV !== 'production') { // 测试和开发打开，生产不能打开
  const vConsole = new Vconsole()
  Vue.use(vConsole)
}

new Vue({
  router,
  store,
  beforeCreate () {
    Vue.prototype.$bus = this // 安装全局事件总线，$bus就是当前应用的vm
  },
  render: h => h(App)
}).$mount('#app')
